import './index.scss';
import '../js/slab-scripts.js';
import './gsap.js';